export default {
    title: "Doporučení poradců",
    noItems: "Žádná doporučení"
}